module.exports = __webpack_public_path__ + "img/white-triangle.e9d45305.svg";